import React from 'react';

function MaintenanceBanner({ message }) {
  if (!message) return null;
  return (
    <div style={{
      width: '100%',
      background: 'rgba(59,130,246,0.08)',
      border: '0',
      borderBottom: '1px solid rgba(59,130,246,0.2)',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', gap: 10,
      fontFamily: "'Geist', 'Inter', system-ui, sans-serif"
    }}>
      <span style={{ fontSize: 14 }}>⚙️</span>
      <span style={{ color: '#8b95a8', fontSize: 13, flex: 1 }}>{message}</span>
    </div>
  );
}

export default MaintenanceBanner;
